<template>
  <div
    :class="{
      '-left-64': !loaded || !sideBarVisible,
      'left-0': loaded && sideBarVisible,
      'bg-stone-age': selectedEra === 'stoneAge',
      'bg-bronze-age': selectedEra === 'bronzeAge',
      'bg-minoan-era': selectedEra === 'minoanEra',
      'bg-classic-greece': selectedEra === 'classicGreece',
      'bg-early-rome': selectedEra === 'earlyRome',
      'bg-roman-empire': selectedEra === 'romanEmpire',
      'bg-byzantine-era': selectedEra === 'byzantineEra',
      'bg-age-of-the-franks': selectedEra === 'ageOfTheFranks',
      'bg-feudal-age': selectedEra === 'feudalAge',
      'bg-iberian-era': selectedEra === 'iberianEra',
      'bg-kingdom-of-sicily': selectedEra === 'kingdomOfSicily',
      'bg-high-middle-ages': selectedEra === 'highMiddleAges',
      'bg-early-gothic-era': selectedEra === 'earlyGothicEra',
      'bg-late-gothic-era': selectedEra === 'lateGothicEra',
    }"
    class="absolute w-64 h-full top-0 anim-left flex-col flex"
  >
    <div
      class="w-full text-2xl p-4 font-oswald text-white leading-none flex flex-row items-center cursor-pointer select-none"
      @click="toggleSidebar"
    >
      <span class="flex-grow">
        BUILDINGS
      </span>
      <i class="fas fa-bars"/>
    </div>
    <div
      v-if="sideBarGrip"
      :class="{
        'bg-stone-age': selectedEra === 'stoneAge',
        'bg-bronze-age': selectedEra === 'bronzeAge',
        'bg-minoan-era': selectedEra === 'minoanEra',
        'bg-classic-greece': selectedEra === 'classicGreece',
        'bg-early-rome': selectedEra === 'earlyRome',
        'bg-roman-empire': selectedEra === 'romanEmpire',
        'bg-byzantine-era': selectedEra === 'byzantineEra',
        'bg-age-of-the-franks': selectedEra === 'ageOfTheFranks',
        'bg-feudal-age': selectedEra === 'feudalAge',
        'bg-iberian-era': selectedEra === 'iberianEra',
        'bg-kingdom-of-sicily': selectedEra === 'kingdomOfSicily',
        'bg-high-middle-ages': selectedEra === 'highMiddleAges',
        'bg-early-gothic-era': selectedEra === 'earlyGothicEra',
        'bg-late-gothic-era': selectedEra === 'lateGothicEra',
      }"
      class="left-64 top-0 w-16 h-16 flex items-center justify-center absolute cursor-pointer text-2xl text-white rounded-br-lg"
      @click="toggleSidebar"
    >
      <i class="fas fa-bars"/>
    </div>
    <div
      class="flex flex-col w-full relative bg-black flex-grow"
    >
      <BuildingItem
        v-for="(bData, bType) in buildings"
        :key="bType"
        :building-data="bData"
        :building-type="bType"
        :class="{
          'flex-grow': openedType === bType,
        }"
        :era="selectedEra"
        :is-open="openedType === bType"
        @open="onOpen"
        @select="selectBuilding"
      />
    </div>
    <div
      class="w-full text-2xl p-4 cursor-pointer font-oswald transition duration-300 text-white leading-none hover:opacity-75"
      title="Start new layout"
      @click="createNewLayout"
    >
      START A NEW LAYOUT
    </div>
  </div>
</template>

<script>
import Eras from "@/roc/era";
import Buildings from "@/roc/building";
import BuildingType, {getBuildingTypeName, isWorkShop} from "@/roc/building/BuildingType";
import BuildingItem from "@/components/Menu/BuildingItem.vue";
import {computed, onMounted, ref} from 'vue';
import {useApplicationStore} from '@/roc/stores/ApplicationStore';
import {useLayoutStore} from '@/roc/stores/LayoutStore';

export default {
  components: {
    BuildingItem
  },
  emits: ['newLayout'],
  setup (_, context) {
    const appStore = useApplicationStore();
    const lytStore = useLayoutStore();

    const eraPriorityList = [];
    const loaded = ref(false);
    const openedType = ref(BuildingType.HOME);
    const sideBarVisible = ref(true);
    const sideBarGrip = ref(false);

    for (const i in Eras) {
      eraPriorityList.push(i);
    }

    onMounted(() => {
      setTimeout(() => {
        loaded.value = true;
      }, 100);
    })

    return {
      loaded,
      openedType,
      sideBarVisible,
      sideBarGrip,

      selectedEra: computed(() => appStore.selectedEra),

      buildings: computed(() => {
        const result = {};
        const selectedEraPriority = eraPriorityList.indexOf(
          appStore.selectedEra
        );

        for (let i = 0; i < Buildings.length; i++) {
          if (BuildingType.CITY_HALL === Buildings[i].type) {
            continue;
          }

          const eraPriority = eraPriorityList.indexOf(Buildings[i].era);
          if (eraPriority <= selectedEraPriority) {
            let bType = Buildings[i].type;
            if (isWorkShop(Buildings[i].type)) {
              bType = "workshop";
            }

            if (result[bType] === undefined) {
              result[bType] = {
                title: getBuildingTypeName(Buildings[i].type),
                items: []
              };
            }

            result[bType].items.push({
              id: Buildings[i].id,
              name: Buildings[i].name,
              count: lytStore.getCountById(Buildings[i].id),
              maxCount: Buildings[i].counts || {},
              type: Buildings[i].type
            });
          }
        }
        return result;
      }),

      selectBuilding (templateId) {
        appStore.queueBuildingCreation(templateId);
      },

      createNewLayout () {
        context.emit('newLayout');
      },

      onOpen (type) {
        openedType.value = type;
      },

      toggleSidebar () {
        sideBarVisible.value = !sideBarVisible.value;
        if (!sideBarVisible.value) {
          setTimeout(() => {
            sideBarGrip.value = true;
          }, 300);
        } else {
          sideBarGrip.value = false;
        }
      }
    };
  }
};
</script>

<style>
.anim-left {
  transition: left 300ms ease-in-out;
}
</style>
